import angular from 'angular'

import PopoverDefaultController from './vd-popover-default.controller'
import PopoverComponent from './vd-popover.component'
import PopoverService from './vd-popover.service'

angular
  .module('vend.ui')
  .controller('PopoverDefaultController', PopoverDefaultController)
  .component('vdPopover', PopoverComponent)
  .service('vdPopover', PopoverService)
